/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelBlockquote64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelBlockquote64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17 22C16.4477 22 16 22.4477 16 23V28.5C16 28.6326 16.0527 28.7598 16.1464 28.8536L21.1464 33.8536L21.8536 33.1464L17.7071 29H22C22.5523 29 23 28.5523 23 28V23C23 22.4477 22.5523 22 22 22H17ZM17 23V28H22V23H17Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26 22C25.4477 22 25 22.4477 25 23V28.5C25 28.6326 25.0527 28.7598 25.1464 28.8536L30.1464 33.8536L30.8536 33.1464L26.7071 29H31C31.5523 29 32 28.5523 32 28V23C32 22.4477 31.5523 22 31 22H26ZM26 23V28H31V23H26Z"
              fill="currentColor"
            />
          </g>
          <g opacity="0.22">
            <path d="M16 39L48 39V38L16 38V39Z" fill="currentColor" />
            <path d="M16 45L32 45V44L16 44V45Z" fill="currentColor" />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelBlockquote64Icon.tags = [
  'blockquote',
  'quote',
  'text',
  'speech',
  'citation',
];

AddPanelBlockquote64Icon.category = '64x64 (Add panel)';

AddPanelBlockquote64Icon.iconSize = 64;
